import React from "react";
import * as THREE from "three";

interface ReferencePlaneProps {
  size?: number;
  visible: boolean;
}

export function ReferencePlane({ size = 6000, visible }: ReferencePlaneProps) {
  if (!visible) return null;

  return (
    <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0, 0]}>
      <circleGeometry args={[size, 64]} />
      <meshBasicMaterial
        color="#1a3a5c"
        transparent
        opacity={0.12}
        side={THREE.DoubleSide}
        depthWrite={false}
      />
    </mesh>
  );
}
